export const initStickyYear = () => {
  const blogListContainerEl = document.querySelector<HTMLElement>('.Blog-list-container')
  const stickyYearEl = document.querySelector<HTMLElement>('.Sticky-year')

  if (!blogListContainerEl || !stickyYearEl) {
    return
  }
  const initialYear =
    blogListContainerEl.querySelectorAll<HTMLElement>('.Blog-item')?.[0].dataset.year

  if (initialYear) {
    stickyYearEl.textContent = initialYear
  }
}

export const updateStickyYearOnScroll = (isArabicStore: boolean) => {
  const blogContainerEl = document.querySelector<HTMLElement>('.Blog-container')
  const blogListContainerEl = document.querySelector<HTMLElement>('.Blog-list-container')
  const stickyYearEl = document.querySelector<HTMLElement>('.Sticky-year')

  if (!blogContainerEl || !blogListContainerEl || !stickyYearEl) {
    return
  }

  if (!stickyYearEl.textContent) {
    initStickyYear()
  }

  // remove sticky of year
  if (
    blogContainerEl.getBoundingClientRect().top > 0 ||
    window.pageYOffset + window.innerHeight / 2 >
      (document.querySelector<HTMLElement>('.footer')?.offsetTop ?? 0)
  ) {
    stickyYearEl.classList.remove('isSticky')

    if (isArabicStore) {
      stickyYearEl.style.marginRight = 'auto'
    } else {
      stickyYearEl.style.marginLeft = 'auto'
    }

    stickyYearEl.style.top = '0'
    return
  }

  // add sticky of year
  stickyYearEl.classList.add('isSticky')

  if (isArabicStore) {
    stickyYearEl.style.marginRight = -blogContainerEl.clientWidth / 2 + 'px'
  } else {
    stickyYearEl.style.marginLeft = -blogContainerEl.clientWidth / 2 + 'px'
  }

  if (blogContainerEl.getBoundingClientRect().top != stickyYearEl.getBoundingClientRect().top) {
    stickyYearEl.style.top = blogListContainerEl.offsetTop + 'px'
  }

  // update dynamically year
  const els = blogListContainerEl.querySelectorAll<HTMLElement>('.Blog-item')
  for (let i = 0; i < els.length; i++) {
    const { top: topBlogItem } = els[i].getBoundingClientRect()
    const { top: topYear } = stickyYearEl.getBoundingClientRect()
    const { year: newYear } = els[i].dataset

    if (topBlogItem < topYear && newYear) {
      stickyYearEl.textContent = newYear
    }
  }
}
